<script setup>
import { onBeforeMount, ref, defineAsyncComponent, shallowRef } from 'vue';
import { useRoute } from 'vue-router';
import opmStore from '@/lib/storeOwnerProjectManager';

const route = useRoute();

const pageData = ref();
const actions = ref();
const form = ref();

// Dynamically import the component based on the route parameter
const entityTypeComponent = shallowRef(null);

import { useButtonType, useButtonClick } from "@/assets/modules/composables/button.js";
const { buttonType } = useButtonType();
const { buttonClick } = useButtonClick(pageData, form);

onBeforeMount(async() => {
    entityTypeComponent.value = defineAsyncComponent(() =>
        import(`@/components/views/forms/${route.params.entity_type}Form.vue`)
    );
    let query = [];
    if(route?.query?.refetchSchemas){
        query.push({
            key: 'refetchSchemas',
            value: route.query.refetchSchemas,
        });
    }
    const response = await opmStore.dispatch("getPageData",{
        entityType: route.params.entity_type,
        entityId: route.params.entity_id,
        fetchType: route.params.fetch_type,
        isMainData: true,
        query,
    });
    if(response?.success){
        pageData.value = response.data;
        opmStore.dispatch("setBreadcrumbs", response.meta.breadcrumbs);
        actions.value = response.meta.actions ||[];
    }
})
</script>

<template>
    <v-container fluid v-if='pageData'>
        <v-form ref="form" lazy-validation>
            <v-row>
                <v-col>
                    <h1>{{ pageData.pageName }}</h1>
                </v-col>
            </v-row>


            <!-- Dynamically render the imported component -->
            <component 
                :is="entityTypeComponent" 
                v-if="entityTypeComponent"
                :pageData="pageData"
                >
            </component>




            <v-row v-if="actions.length">
                <v-col class="d-flex ga-4 justify-end">
                    <v-btn
                        v-for="action in actions" :key="action.href"    
                        color="primary" 
                        :variant="buttonType(action.importance)" 
                        @click="buttonClick(action)"
                        :loading="action.submitting" 
                        :disabled="action.submitting"
                    >
                        {{action.title}}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>